import type { Invoice } from "@nlc/shared-types";

import { BanknoteIcon, DownloadIcon, EyeIcon, LinkIcon } from "lucide-react";

import { Button } from "@/components/button";
import { cn } from "@/utils/cn";

interface InvoiceActionButtonsProps {
  invoice: Invoice;
  onCopyLink: (invoice: Invoice) => void;
  onIssueCredit?: (invoice: Invoice) => void;
}

export function InvoiceActionButtons({
  invoice,
  onCopyLink,
  onIssueCredit,
}: InvoiceActionButtonsProps) {
  return (
    <div className="grid grid-cols-2 gap-x-md gap-y-lg">
      <Button className="w-full" size="sm" variant="secondary">
        <EyeIcon size={16} />
        View invoice
      </Button>

      <Button
        className="w-full"
        onPress={() => onCopyLink(invoice)}
        size="sm"
        variant="secondary"
      >
        <LinkIcon size={16} />
        Copy link
      </Button>

      <Button
        className={cn("w-full", !onIssueCredit && "col-span-2")}
        size="sm"
        variant="secondary"
      >
        <DownloadIcon size={16} />
        Download
      </Button>

      {onIssueCredit && (
        <Button
          className="w-full"
          onPress={() => onIssueCredit(invoice)}
          size="sm"
          variant="secondary"
        >
          <BanknoteIcon size={16} />
          Issue a credit
        </Button>
      )}
    </div>
  );
}
